import React from 'react';
import UnifiedSearchPage from './common/UnifiedSearchPage';
import { fetchDetailedInvoices } from '../services/dataService';
import usePageTitle from '../utils/usePageTitle';

const DetailedInvoice = () => {
  usePageTitle('Detailed Invoice');

  const getRowLink = (row) => `/invoice/detailed/${row.projectCode}`;

  const columns = [
    { key: 'projectCode', label: 'Project Code' },
    { key: 'budgetCode', label: 'Budget Code' },
    { key: 'requestorName', label: 'Requestor Name' },
    { key: 'personInCharge', label: 'Person In Charge' },
    { key: 'modelName', label: 'Model Name' },
    { key: 'projectStatus', label: 'Project Status' }
  ];

  return (
    <UnifiedSearchPage
      title="Detailed Invoice"
      columns={columns}
      getRowLink={getRowLink}
      loadDataFunction={fetchDetailedInvoices}
    />
  );
};

export default DetailedInvoice;